import apiAxios from "../../../api/api";

export const getUsers = async (pageParams, filters) => {
    try {
        const res = await apiAxios.post('/admin/users', { pageParams, filters });
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const addUser = async (data) => {
    try {
        const res = await apiAxios.post('/admin/addusers', data);
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const updateUser = async (data, id) => {
    try {
        const res = await apiAxios.put(`/admin/editusers/${id}`, data);
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const userStatus = async (id, status) => {
    try {
        const res = await apiAxios.post(`/admin/userstatus/${id}`, { status });
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}
//////////Department////////////////////////
export const getDepartments = async () => {
    try {
        const res = await apiAxios.get('/admin/departments');
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const addDepartment = async (data) => {
    try {
        const res = await apiAxios.post('/admin/departments', data);
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const updateDepartment = async (data, id) => {
    try {
        const res = await apiAxios.put(`/admin/departments/${id}`, data);
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const statusChangeDepartment = async (id, status) => {
    try {
        const res = await apiAxios.post(`/admin/delete/departments/${id}`, { status });
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}
/////////End Department////////////////////////

//////////Document Hierarchy////////////////////////
export const getDocumentHierarchy = async () => {
    try {
        const res = await apiAxios.get('/admin/document-hierarchy');
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const addDocumentHierarchy = async (data) => {
    try {
        const res = await apiAxios.post('/admin/document-hierarchy', data);
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const updateDocumentHierarchy = async (data, id) => {
    try {
        const res = await apiAxios.put(`/admin/document-hierarchy/${id}`, data);
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}
//////////End Document Hierarchy////////////////////////


/////////Document/////////////////
export const uploadDocument = async (data) => {
    try {
        const res = await apiAxios.post('/admin/uploaddoc', data);
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const editDocument = async (data, id) => {
    try {
        const res = await apiAxios.put(`/admin/editdoc/${id}`, data);
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const replaceDocument = async (data, id) => {
    try {
        const res = await apiAxios.put(`/admin/replacedoc/${id}`, data);
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const deactiveDocument = async (id, reason) => {
    try {
        const res = await apiAxios.post(`/admin/deactive/doc/${id}`, {reason});
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const getDocLastNumber = async (department, hierarchy) => {
    try {
        const res = await apiAxios.post(`/admin/get-doc-last-number`, {department, hierarchy});
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}
/////////End Documents///////////////

/////////Footer/////////////////
export const addFooter = async (data) => {
    try {
        const res = await apiAxios.post('/admin/addfooter', data);
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const editFooterRequest = async (data, id) => {
    try {
        const res = await apiAxios.put(`/admin/editfooter/${id}`, data);
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}

export const getFooter = async (is_active) => {
    try {
        const res = await apiAxios.post('/admin/footer', {is_active: is_active});
        return res.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}
/////////End Footer/////////////////